import React from 'react';
import { useQuery } from 'react-query';
import { getAssetHistory } from 'config/api';
import Loading from 'components/commons/loading/Loading';
import { AssetHistoryItemsProps } from 'components/features/home/assetStuffing/AssetStuffing';
import { AssetTransitionChart } from './AssetTransitionChart';
import { AdvisorComment } from './AdvisorComment';
import { ReportBaseProps } from '../../weekly-report/WeeklyReport';

export const AssetTransition = ({
  Base,
  userName,
  queryPeriod,
}: {
  Base: ReportBaseProps;
  userName: string;
  queryPeriod: {
    from: string;
    to: string;
  };
}) => {
  const { data: transitionsData, isFetching, isRefetching } = useQuery(
    'monthlyTransitions',
    () => fetchTransitions(queryPeriod.from, queryPeriod.to),
    {
      refetchOnWindowFocus: false,
    }
  );

  if (
    (isFetching && isRefetching) ||
    transitionsData === null ||
    transitionsData === undefined
  )
    return <LoadingData />;

  const transitions = transitionsData as AssetHistoryItemsProps[];

  return (
    <>
      <AssetTransitionChart
        {...{
          transitions,
          previousTotalAssetAmount: Base.PreviousTotalAssetAmount,
          queryPeriod,
        }}
      />
      <AdvisorComment {...{ Base, userName, transitions }} />
    </>
  );
};

const LoadingData = () => {
  return (
    <>
      <div className="flex items-center mb-3 text-base font-bold text-bluegray-700">
        1ヶ月の資産推移
      </div>
      <Loading
        loading={true}
        circularLoading={true}
        style={{
          paddingTop: '60px',
          paddingBottom: '60px',
        }}
      />
    </>
  );
};

const fetchTransitions = async (from: string, to: string) => {
  const res_ = await getAssetHistory(from, to, undefined, false);
  const res = res_.Items.map(item => {
    return {
      day: item.Day,
      totalAssetAmount: item.TotalAssetAmount,
      diffTotalAssetAmount: item.DiffTotalAssetAmount,
      diffTotalAssetRate: item.DiffTotalAssetRate,
      marginProfitOrLoss: item.MarginProfitOrLoss,
      totalProfitOrLoss: item.TotalProfitOrLoss,
      diffTotalProfitOrLoss: item.DiffTotalProfitOrLoss,
      diffTotalProfitOrLossRate: item.DiffTotalProfitOrLossRate,
      stockAmount: item.StockAmount,
      marginAmount: item.MarginAmount,
      roboAdvisorAmount: item.RoboAdvisorAmount,
      uSStockAmount: item.USStockAmount,
      investmentTrustAmount: item.InvestmentTrustAmount,
      unlistedStockAmount: item.UnlistedStockAmount,
      etfEtnAmount: item.EtfEtnAmount,
      foreignEtfEtnAmount: item.ForeignEtfEtnAmount,
      reitAmount: item.ReitAmount,
      foreignReitAmount: item.ForeignReitAmount,
      bondAmount: item.BondAmount,
      foreignBondAmount: item.ForeignBondAmount,
      ebAmount: item.EbAmount,
      foreignEbAmount: item.ForeignEbAmount,
      realEstateAmount: item.RealEstateAmount,
      cashAmount: item.CashAmount,
      otherAmount: item.OtherAmount,
      incorrect: item.Incorrect,
      topix: item.Topix ?? null,
    };
  });
  return res;
};
